// @ts-nocheck

// components/atoms/Snackbar/index.tsx
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertColor, Slide } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MuiSnackbar, { SnackbarCloseReason, SnackbarOrigin } from '@mui/material/Snackbar';
import styles from '@/components/atoms/Snakebar/Snakebar.module.css';

function SlideTransition(props: TransitionProps) {
  return <Slide {...props} direction="up" />;
}

export interface AtomSnackbarProps {
  message: string;
  variant?: 'success' | 'warning' | 'error' | 'info';
  open?: boolean;
  autoHideDuration?: number;
  onClose?: (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => void;
  action?: React.ReactNode;
  anchorOrigin?: SnackbarOrigin;
}

const AtomSnackbar: React.FC<AtomSnackbarProps> = ({
  message,
  variant = 'info',
  open = false,
  autoHideDuration = 5000,
  onClose,
  action,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
}) => {
  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose?.(event, reason);
  };

  const defaultAction = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={e => handleClose(e, 'closeButtonClick')}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      className={styles.snackbarContainer}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={handleClose as any}
        severity={variant as AlertColor}
        variant="filled"
        className={styles.alert}
        action={
          <div className={styles.actionContainer}>
            {action}
            {defaultAction}
          </div>
        }
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default AtomSnackbar;
